import {collectEnumValues} from '../../libs/shared/helpers/src/typescript/enumHelpers';

export enum AppRoutesPrefixesEnum {
  CALENDAR = 'calendar',
  CALENDARS = 'calendars',
  INBOXES = 'inboxes',
  V2VISITORS = 'v2/visitors',
  VISITORS = 'visitors',
  ANALYTICS = 'analytics',
  SETTINGS = 'settings',
  SEQUENCES = 'sequences',
  AUDIT_TRAIL = 'activities',

  // Contacts Manager
  CONTACTS_MANAGER = 'contacts-manager',
  CONTACTS_MANAGER_ACCOUNTS = 'contacts-manager/accounts',
  CONTACTS_MANAGER_CONTACTS = 'contacts-manager/contacts',
  CONTACTS = 'contacts',
}

export const appRoutesPrefixes = collectEnumValues(AppRoutesPrefixesEnum);
